import React from 'react';
import classNames from 'classnames';

interface ToggleSwitchProps {
  leftLabel: string;
  rightLabel: string;
  value: boolean;
  onChange: (value: boolean) => void;
}

export default function ToggleSwitch({ leftLabel, rightLabel, value, onChange }: ToggleSwitchProps) {
  return (
    <div className="relative flex rounded-lg bg-secondary-50">
      <button
        type="button"
        onClick={() => onChange(false)}
        className="text-md relative z-10 flex-1 p-3 font-medium text-primary transition-colors">
        {leftLabel}
      </button>
      <button
        type="button"
        onClick={() => onChange(true)}
        className="text-md relative z-10 flex-1 p-3 font-medium text-primary transition-colors">
        {rightLabel}
      </button>
      <div
        className={classNames('absolute top-0 h-full p-1 transition-all', value ? 'left-1/2' : 'left-0')}
        style={{ width: '50%' }}>
        <div className="h-full rounded-lg bg-secondary" />
      </div>
    </div>
  );
}
